import CONFIG from './config-backend.js';
import { fetchAuth } from './fetchAuth.js';
import { showError } from './notify.js';

document.addEventListener('DOMContentLoaded', () => {
  const spinner = document.getElementById('spinnerContainer');
  spinner.style.display = 'flex';

  Promise.all([
    fetchAuth(`${CONFIG.BACKEND_URL}/crawler/ecs/cluster`, { method: 'GET' }).then(r => r.json()),
    fetchAuth(`${CONFIG.BACKEND_URL}/crawler/ecs/services`, { method: 'GET' }).then(r => r.json()),
  ])
    .then(([cluster, services]) => {
      const running = services.filter(s => s.runningCount > 0).length;
      const stopped = services.filter(s => s.desiredCount === 0).length;

      const tableBody = document.querySelector('#dataTable tbody');
      const row = document.createElement('tr');
      row.style.cursor = 'pointer';
      row.addEventListener('click', () => {
        sessionStorage.setItem('clusterData', JSON.stringify({ cluster, services }));
        window.location.href = `enviroment-details`;
      });

      const statusBadge = cluster.status === 'ACTIVE'
        ? '<span class="badge badge-soft-success">ACTIVE</span>'
        : `<span class="badge badge-soft-danger">${cluster.status}</span>`;

      row.innerHTML = `
        <td>${cluster.name}</td>
        <td>${cluster.activeServices}</td>
        <td>${cluster.runningTasks}</td>
        <td>${cluster.pendingTasks}</td>
        <td>${running}</td>
        <td>${stopped}</td>
        <td>${statusBadge}</td>
      `;
      tableBody.append(row);
    })
    .catch(() => showError('Could not load cluster information. Check your connection.'))
    .finally(() => {
      spinner.style.display = 'none';
      spinner.classList.remove('d-flex');
    });
});
